import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { AdminAddCustomerFormComponent } from "../components";
import { AdminDefaultLayout } from "../layouts/adminDefaultLayout";
// const userFormData = [
//   {
//     name: '',
//     type: 'text',
//   },
//   {
//     email: '',
//     type: 'email',
//   },
// ];

const columns = [
  { header: "Name", propName: "name" },
  { header: "Email", propName: "customer.contactEmail" },
  { header: "Status", propName: "customer.status" },
  { header: "Renewal Date", propName: "customer.endDate" },
  // Add other columns as needed
];

const actions = [
  {
    name: "Edit",
    method: (item: any) => {
      /* handle edit */
    },
  },
  {
    name: "Delete",
    method: (item: any) => {
      /* handle delete */
    },
  },
];

export const AdminCustomersComponent = () => {
  const [formOpen, setFormOpen] = useState(false);
  //const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState({});
  const [inputs, setInputs] = useState({});

  const handleFormButtonClick = () => {
    setIsEditing(false);
    setFormOpen(!formOpen);
  };

  // handles customer selection and open modal
  const handleCustomerButtonClick = (customer: any) => {
    console.log("customer for editing", customer);
    setIsEditing(true);
    setEditingCustomer(customer);
    setFormOpen(!formOpen);
  };

  const setReset = () => {
    if (isEditing) {
      //reset to defaults
      setEditingCustomer({});
      setIsEditing(false);
      setFormOpen(!formOpen);
    } else {
      setFormOpen(!formOpen);
    }
  };

  return (
    <>
      <AdminDefaultLayout
        openForm={handleFormButtonClick}
        formButtonTitle="Customer"
        actions={actions}
        columns={columns}
        header={"Customers"}
        searchType="current-customer"
        onItemSelect={handleCustomerButtonClick}
      ></AdminDefaultLayout>

      {/* TODO: MAKE THIS REUSABLE ACROSS ALL OF THE ADD FORMS */}
      <Modal show={formOpen} onHide={handleFormButtonClick} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Update Customer" : "Add Customer"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AdminAddCustomerFormComponent
            closeForm={handleFormButtonClick}
            data={editingCustomer}
            setInputs={setInputs}
            editing={isEditing}
            setReset={setReset}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
